import api from 'service/api'

const dponetAPI = api.create('cookies')

const get = async (params) => await dponetAPI.get('/consents', { params })
const getStats = async (params) =>
  await dponetAPI.get('/consents/stats', { params })
const getStatsByBanner = async () =>
  await dponetAPI.get('/consents/stats_by_banner')

export default {
  get,
  getStats,
  getStatsByBanner,
}
